import {takeLatest} from 'redux-saga/effects';

import {createBeer} from './create/saga';
import {deleteBeerSaga} from './delete/saga';
import {getBeers} from './get/saga';
import {getBeerPubsSaga} from './getBeerPubs/getBeerPubs';
import {getSocialMediaStatisticSaga} from './getBeersSocialMediaStatistic/saga';
import {
  createBeerACS,
  getBeersACS,
  updateSingleBeerACS,
  getBeerPubsACS,
  deleteBeerACS,
  getBeerSocialMediaStatisticACS,
} from './requestAC';
import {updateBeer} from './single/saga';

export default function* beersSaga() {
  yield takeLatest(getBeersACS.type, getBeers);
  yield takeLatest(createBeerACS.type, createBeer);
  yield takeLatest(updateSingleBeerACS.type, updateBeer);
  yield takeLatest(getBeerPubsACS.type, getBeerPubsSaga);
  yield takeLatest(deleteBeerACS.type, deleteBeerSaga);
  yield takeLatest(getBeerSocialMediaStatisticACS.type, getSocialMediaStatisticSaga);
}
